import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { normalizeRequestedPath } from '@/lib/tenantNavigation';

export default function LoginGate({ next }: { next: string }): JSX.Element {
  const nextPath = normalizeRequestedPath(next) ?? '/dashboard';
  const loginTarget = {
    pathname: '/auth/login',
    search: `?next=${encodeURIComponent(nextPath)}`,
  };

  return (
    <div className="mx-auto max-w-md rounded-xl border p-6 text-center">
      <h2 className="mb-2 text-xl font-semibold">Please sign in</h2>
      <p className="mb-4 text-muted-foreground">You need to be signed in to view this page.</p>
      <Link to={loginTarget} state={{ from: nextPath }}>
        <Button>Sign in</Button>
      </Link>
    </div>
  );
}
